import { render, staticRenderFns } from "./setTree.vue?vue&type=template&id=45e818f4&scoped=true&"
import script from "./setTree.vue?vue&type=script&lang=js&"
export * from "./setTree.vue?vue&type=script&lang=js&"
import style0 from "./setTree.vue?vue&type=style&index=0&id=45e818f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e818f4",
  null
  
)

export default component.exports